import { Vertical } from 'gls';
import styled from 'styled-components';
import { colours } from 'styling/colours';
import LocationCell from './LocationCell';
import { Device } from 'types/device';
import LastSeenCell from 'views/assets/AssetList/components/LastSeenCell';

type MobileDeviceColumnProps = {
  device: Device;
};
export const MobileRow = ({ device }: MobileDeviceColumnProps) => {

  return (

    <ContainerStyle>
      <Vertical spacing={10}>
        <span className="device-id">{device.device_id}</span>
        <table>
          <thead>
            <tr>
              <td className="title">LAST SEEN:</td>
              <td>
                {device.last_update_timestamp ? (
                  <LastSeenCell timestamp={device.last_update_timestamp} />
                ) : (
                  '––'
                )}
              </td>
            </tr>
          </thead>
          <thead>
            <tr>
              <td className="title">LOCATION:</td>
              <td>
                <LocationCell value={device} />
              </td>
            </tr>
          </thead>
        </table>
      </Vertical>
    </ContainerStyle>
  );
};

const ContainerStyle = styled.div`
  width: 100%;

  table td {
    vertical-align: top;
    padding-bottom: 4px;
  }
  .title {
    width: 100px;
    color: ${colours.primary};
  }
  .asset-name {
    font-weight: bold;
  }
`;
